import profilePic from './Assets/Profile.png'
import quds from './Assets/Quds.png'
import blog1 from './Assets/Blog1.jpg'
import blog2 from './Assets/Blog2.jpeg'
import blog3 from './Assets/Blog3.jpeg'
import website from './Assets/website.png'
import whatsapp from './Assets/whatsapp.png'
import instagram from './Assets/instagram.jpg'

import profileThumbnail from './Assets/ProfileThumbnail.png'

export const data = {
	website: {
		theme: {
			direction: 'rtl',
			mode: 'dark',
			primaryColor: '#ffffff',
			secondaryColor: '#D0ECF5',
			primaryBackground: '#113037',
			secondaryBackground: '#1d4953',
		},
		info: {
			profilePic: profilePic,
			thumbnail: profileThumbnail,
			name: 'محمود عويضة',
			bio: 'مؤسس شركة نهى للبرمجيات 🖥️\nنقدم حلول برمجية تلبي احتياجات مشروعك 📈',
		},
		social: {
			instagram: 'https://www.instagram.com/owa1da/',
			twitter: 'https://twitter.com/owa1da',
			thread: 'https://www.threads.net/@owa1da',
			linkedin: 'https://www.linkedin.com/in/owa1da/',
		},
		content: {
			a1: {
				type: 'cardBlock',
				title: 'لعبة طوفان الأقصى',
				description: 'لعبة تعليمية ممتعة تهدف إلى تثقيف اللاعبين حول تاريخ وثقافة الأقصى.',
				thumbnail: quds,
				link: 'https://toofanalaqsa.net/',
				action: 'اختبر معلوماتك', 
				color: '#ffffff',
				background: '#E0AC25'
			},
			a2: {
				type: 'linkFolder',
				title: 'روابط مهمة',
				cards: {
					b1: {
						title: 'موقع الشركة الرسمي',
						description: 'اقرأ المزيد عن خدماتنا ومشاريعنا على موقع الشركة الرسمي.',
						thumbnail: website,
						link: 'https://nuhaverse.com',
						action: 'شاهد المزيد'
					},
					b2: {
						title: 'تواصل معنا على الواتساب',
						description: 'تواصل معنا عبر الواتساب للحصول على استشارات أو خدمات',
						thumbnail: whatsapp,
						link: 'https://api.whatsapp.com/send/?phone=962791807251&text=%D9%85%D8%B1%D8%AD%D8%A8%D8%A7+Nuha%2C+%D8%A3%D8%B1%D9%8A%D8%AF+%D9%85%D8%B9%D8%B1%D9%81%D8%A9+%D8%A7%D9%84%D9%85%D8%B2%D9%8A%D8%AF+%D8%B9%D9%86+%D8%AE%D8%AF%D9%85%D8%A7%D8%AA%D9%83%D9%85&type=phone_number&app_absent=0',
						action: 'أرسل رسالة'
					},
					b3: {
						title: 'تابعني على اننستغرام',
						description: 'تابعني على انستغرام للحصول على آخر التحديثات والمنشورات.',
						thumbnail: instagram,
						link: 'https://instagram.com/owa1da',
						action: 'تابعني'
					},
				}
			},
			a3: {
				type: 'textBlock',
				text: 'مرحباً بكم في موقعي الشخصي 👋 هنا ستجد كل ما تحتاجه لمعرفة المزيد عني وعن خدماتي في مجال البرمجيات. 🖥️ ⚙️',
			},
			a4: {
				type: 'contactList',
				title: 'انضم إلى النشرة البريدية',
				description: 'اشترك في النشرة البريدية لتصلك آخر المقالات والأخبار المتعلقة بالبرمجة وتطوير البرمجيات.',
				contactType: 'email',
			}
		},
		posts: {
			1: {
				date: '2021-08-01',
				title: 'كيفية تحقيق النجاح في عالم البرمجة',
				description: 'مقالة جديدة تتحدث عن كيفية تحقيق النجاح في عالم البرمجة',
				thumbnail: blog1,
				body: 'في هذه المقالة، سنستعرض أهم الخطوات والنصائح لتحقيق النجاح في مجال تطوير البرمجيات. تبدأ الرحلة من التعلم والتدريب المستمر على أحدث التقنيات واللغات البرمجية. \n \n البحث عن المصادر التعليمية الموثوقة، مثل الدورات التدريبية على منصات التعلم الإلكتروني، والكتب المتخصصة، والمشاركة في المنتديات والمجتمعات التقنية، يعد من أهم خطوات بناء قاعدة معرفية قوية. \n\n بعد اكتساب المعرفة الأساسية، يجب التركيز على التطبيق العملي من خلال بناء مشاريع صغيرة ثم التدرج إلى مشاريع أكثر تعقيدًا. هذه المشاريع تعزز الفهم العميق للمفاهيم البرمجية وتساعد في تطوير مهارات حل المشكلات. \n\n العمل على تطوير مهارات التفكير النقدي والتحليلي يمكن أن يحدث فرقًا كبيرًا في مسيرة المبرمج. من الضروري أيضًا متابعة التحديثات والتطورات في مجال التكنولوجيا لضمان البقاء على اطلاع دائم بكل ما هو جديد. \n\n ولا ننسى أهمية بناء شبكة علاقات مهنية مع خبراء وزملاء في نفس المجال، والتي قد تفتح آفاقًا وفرصًا جديدة في الحياة المهنية. في النهاية، المثابرة والصبر هما المفتاحان الرئيسيان لتحقيق النجاح في عالم البرمجة.'
			},
			2: {
				date: '2021-08-02',
				title: 'أهمية العمل الجماعي في تطوير البرمجيات',
				description: 'مقالة جديدة تناقش أهمية العمل الجماعي في تطوير البرمجيات',
				thumbnail: blog2,
				body: 'في هذا المقال، سنناقش كيف يمكن للعمل الجماعي أن يعزز من جودة البرمجيات المنتجة ويسهم في تحقيق الأهداف المشتركة بسرعة وكفاءة. \n\n العمل الجماعي يمكن الفرق من تبادل الأفكار والمعرفة، مما يؤدي إلى حلول مبتكرة وتطوير أفضل للمشاريع. تعدد وجهات النظر يساعد على تحديد المشكلات المحتملة مبكرًا ومعالجتها بفعالية. \n\n التعاون الفعال يتطلب التواصل الجيد بين أعضاء الفريق. استخدام أدوات التواصل الحديثة مثل Slack وTrello يمكن أن يسهل من تنظيم المهام ومتابعة التقدم بشكل مستمر. \n\n تقسيم الأدوار والمسؤوليات بناءً على مهارات وخبرات كل عضو في الفريق يضمن توزيع العمل بشكل عادل ويساعد على تحقيق أفضل النتائج. \n\n كما أن العمل الجماعي يعزز من روح الفريق والشعور بالانتماء، مما يزيد من التحفيز والإنتاجية لدى الأفراد. عندما يحقق الفريق نجاحًا، يكون الفضل مشتركًا، مما يزيد من الحافز للعمل على مشاريع مستقبلية بتفانٍ أكبر.'
			},
			3: {
				date: '2021-08-03',
				title: 'أحدث تقنيات تطوير البرمجيات',
				description: 'مقالة جديدة عن أحدث تقنيات تطوير البرمجيات',
				thumbnail: blog3,
				body: 'في هذا المقال، سنتناول أحدث التقنيات والأدوات المستخدمة في تطوير البرمجيات، وكيفية الاستفادة منها لتحسين جودة وكفاءة التطبيقات. \n\n من أبرز التقنيات الحديثة هو استخدام الذكاء الاصطناعي والتعلم الآلي في تطوير البرمجيات. هذه التقنيات تمكن التطبيقات من التعلم والتحسن بمرور الوقت دون تدخل بشري مباشر، مما يفتح آفاقًا جديدة في مجالات مثل تحليل البيانات والتنبؤ بالسلوك المستقبلي للمستخدمين. \n\n تقنية الحاويات (Containers) أصبحت شائعة أيضًا بفضل قدرتها على توفير بيئة تشغيل متسقة وقابلة للنقل، مما يسهل عملية النشر والصيانة. أدوات مثل Docker وKubernetes أصبحت جزءًا أساسيًا من عملية تطوير البرمجيات الحديثة. \n\n التطوير السريع للتطبيقات (Rapid Application Development - RAD) هو نهج يركز على السرعة والمرونة في تطوير البرمجيات. هذا النهج يعتمد على استخدام نماذج أولية والتكرار المستمر لتحسين المنتجات بشكل سريع، مما يلبي احتياجات السوق المتغيرة بسرعة. \n\n تقنيات البلوكتشين (Blockchain) بدأت تأخذ حيزًا كبيرًا في تطوير البرمجيات، خاصة في مجالات الأمان والشفافية. التطبيقات القائمة على البلوكتشين تقدم مستويات عالية من الأمان وتقلل من الحاجة إلى وسطاء، مما يجعلها مثالية للتطبيقات المالية واللوجستية. \n\n في الختام، متابعة أحدث التقنيات والأدوات في مجال تطوير البرمجيات يضمن للمطورين القدرة على تقديم حلول مبتكرة وفعالة، وتحقيق نجاح مستدام في هذا المجال المتطور بسرعة.'
			}
		}
	}
}